import merge from '@vuetifyx/utils/merge';
import SwaggerDataProvider from '../SwaggerDataProvider';
import configProvider from "../configProvider"

export default (options: any = {}) => {
    const newOptions: any = merge.clone({
        url: configProvider.get("ASSIGN_REQUEST_SERVICE_URL"),
        ctx: {}
    }, options)

    return new SwaggerDataProvider(newOptions)
}
